

type Light = typeof light;
export const light = {
  primary: "#0062CC",
  color: {
    1: "#232323", // 검은색 젤찐한거/강조,딤
    2: "#4B4B4B", // 진한거
    3: "#646464 ",//기본
    4: "#A2A2A2", //회색글씨, 플레이스 홀더
    5: "#ffffff",
  },

  background: {
    1: "#ffffff",
    2: "#F9F9F9",
    3: "#0062CC",//주요 색상
    4: "#A2A2A2",
    5: "#000000",
  },
};

export const dark: Light = {
  primary: "#2F80ED",
  color: {
    1: "#000000",
    2: "#333333",
    3: "#666666",
    4: "#999999",
    5: "#ffffff",
  },
  background: {
    1: "#ffffff",
    2: "#fafafa",
    3: "#f2f2f2",
    4: "#f4f4f4",
    5: "#000000",
  },
}

declare module '@emotion/react' {
  export interface Theme extends Light {
  }
}
